import gql from 'graphql-tag';

const addPendingVraNoteMutation = gql`
  mutation AddPendingVraNote($input: AddPendingVraNoteInput!) {
    addPendingVraNote(input: $input) {
      success
      errors
      pendingVraNotes {
        returnId
        vra
        notes {
          id
          note
          createdBy
          createdAt
        }
      }
    }
  }
`;

export default addPendingVraNoteMutation;
